import { getSessionHash } from './cta-analytics.js';

function initTracker() {
    const entryId = parseInt(document.body.getAttribute('data-entry-id') || '0', 10);
    if (!entryId) return;

    const actId = document.body.getAttribute('data-act-tracker');
    if (!actId) return;

    const storageKey = 'tracked_' + entryId;
    try {
        if (sessionStorage.getItem(storageKey)) return;
        sessionStorage.setItem(storageKey, '1');
    } catch (e) {
        // sessionStorage unavailable — proceed anyway, server INSERT IGNORE handles dedup
    }

    const fd = new FormData();
    fd.append('entry_id', entryId);
    fd.append('session_hash', getSessionHash());

    const url = '/?ACT=' + actId;

    if (navigator.sendBeacon) {
        navigator.sendBeacon(url, fd);
    } else {
        fetch(url, { method: 'POST', body: fd, keepalive: true }).catch(() => {});
    }
}

export { initTracker };
